export default "__VITE_ASSET__jrfxknNf__"